import React from "react";

export default function FormattedDate (props){

    let daysOfTheWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];  
    let day = daysOfTheWeek[props.date.getDay()];
    let hours = props.date.getHours();
    if (hours < 10) {
        hours = `0${hours}`;
    }
    let minutes = props.date.getMinutes();
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    return (
        <div className = "FormattedDate">
           <p> Last updated {day} {hours}:{minutes} </p> 
        </div>
    );
}